import { Transaction } from '@near-wallet-selector/core';
import JSBI from 'jsbi';
import { Provider } from 'near-api-js/lib/providers';
import { Percentage } from '../../../utils';
import { SwapRoute, SwapStep } from '../route/types';

export enum SwapMode {
  ExactIn = 'ExactIn',
  ExactOut = 'ExactOut',
}
export interface QuoteParams {
  inputMint: string; // User's mint "Swap from"
  outputMint: string; // User's mint "Swap to"
  amount: JSBI;
  slippage: Percentage;
  swapMode: SwapMode;
}

export interface Quote {
  notEnoughLiquidity: boolean;
  amountIn: JSBI; // User's amount "Swap from"
  // TODO: mb add raw amount out, mb rename all fields to be clear what is what
  amountOut: JSBI; // User's amount "Swap to", amount from swap - platform fee
  minAmountOut: JSBI; // amount from swap - slippage
  feeAmount: JSBI;
  feeMint: string;
  feePct: number;
  priceImpact: number;
}

export type PlatformFee = {
  feeBps: number;
  feeAccount: string;
};

export interface SwapParams {
  provider: Provider;
  user: string;
  swapStep: SwapStep;
}

export interface CreateSwapRouteInstructionsParams {
  provider: Provider;
  user: string;
  swapRoute: SwapRoute;
}

// data from rpc for account
export type AccountInfoMap = Map<string, any | null>;

export interface Amm {
  label: string;
  id: string;
  contractId: string; // contact id
  instanceId: number; // pool or OB id
  reserveTokenMints: string[];
  // rename mb
  getPromiseForUpdate({ provider }: { provider: Provider }): Promise<void>;
  getQuote(quoteParams: QuoteParams): Quote; // todo

  // TODO: separate it, should not use any data from AMM => move to static or smth else
  createSwapInstructions(swapParams: SwapParams): Promise<Transaction[]>; // tx for swap step
  createSwapRouteInstructions(
    swapParams: CreateSwapRouteInstructionsParams
  ): Promise<Transaction[]>;
}
